export default __webpack_public_path__ + "static/product-unit-15-at-home-44fe4d2ec09649d1fbd06c4f7b0f8a13.png";